var map = {
	"./arrow-left.png": "a398",
	"./arrow-shop.png": "dea7",
	"./arrow.png": "c5d4",
	"./ballCup/back.png": "afce",
	"./ballCup/cup.png": "7c28",
	"./bark.png": "6900",
	"./book-close-icon.png": "bc96",
	"./book-icon.png": "b52c",
	"./booster0.png": "7cbf",
	"./booster1.png": "9bce",
	"./booster2.png": "5632",
	"./booster3.png": "862c",
	"./booster4.png": "18f4",
	"./booster5.png": "0690",
	"./booster6.png": "b23d",
	"./brush/black.png": "25de",
	"./btn-shine.png": "3c97",
	"./buff/L3-38.png": "ac8d",
	"./buff/blessingCoin.png": "79ba",
	"./buff/blessingFast.png": "3ef9",
	"./buff/coin.png": "7594",
	"./buff/factory.png": "eb72",
	"./buff/malediction.png": "1042",
	"./buff/night.png": "d8fe",
	"./card-holder.png": "e0e2",
	"./card-illustration/L3-38.png": "45fb",
	"./card-illustration/archeological-dig.png": "cc72",
	"./card-illustration/artist-kit.png": "a471",
	"./card-illustration/back-scratcher.png": "8ba6",
	"./card-illustration/barky-boy.png": "8329",
	"./card-illustration/biscuit-chinois.png": "035b",
	"./card-illustration/black-list.png": "9f4c",
	"./card-illustration/blank-canva.png": "6562",
	"./card-illustration/bubble.png": "b2f3",
	"./card-illustration/chemist-kit.png": "9306",
	"./card-illustration/coconut-cake.png": "0ee9",
	"./card-illustration/commercial-road.png": "819a",
	"./card-illustration/crystal-vase.png": "4eac",
	"./card-illustration/cup-and-ball.png": "b812",
	"./card-illustration/diamant.png": "16e9",
	"./card-illustration/diapason.png": "815c",
	"./card-illustration/dirty-cauldron.png": "a62d",
	"./card-illustration/dwarf.png": "2ae0",
	"./card-illustration/emerald-mine.png": "b30d",
	"./card-illustration/emerald.png": "6ccf",
	"./card-illustration/factory-accident.png": "9acb",
	"./card-illustration/fallen-star.png": "a5f0",
	"./card-illustration/fast-worker.png": "904c",
	"./card-illustration/forgotten-safe.png": "285e",
	"./card-illustration/frog-council.png": "afb6",
	"./card-illustration/gambler-watch.png": "443a",
	"./card-illustration/generous-magpie.png": "2a69",
	"./card-illustration/holy-vaccine.png": "ecb4",
	"./card-illustration/kingofdice.png": "867e",
	"./card-illustration/luckycoin.png": "056a",
	"./card-illustration/magician-trick.png": "ab86",
	"./card-illustration/mariage-shop-card.png": "45b1",
	"./card-illustration/moist-camaleon.png": "aec5",
	"./card-illustration/moon rock.png": "2e1b",
	"./card-illustration/mystery-man.png": "5a2e",
	"./card-illustration/necklace.png": "dcc9",
	"./card-illustration/old-donjon.png": "bcc3",
	"./card-illustration/pieceofgum.png": "ce52",
	"./card-illustration/printer.png": "c34a",
	"./card-illustration/queen.png": "7674",
	"./card-illustration/red-riding-hood.png": "07d2",
	"./card-illustration/restricted-section.png": "61f0",
	"./card-illustration/rich-man-wallet.png": "83bc",
	"./card-illustration/risky-dice.png": "74d6",
	"./card-illustration/scary-night.png": "c4ff",
	"./card-illustration/septre.png": "e106",
	"./card-illustration/soapywater.png": "87b2",
	"./card-illustration/squeleton-blessing.png": "4c1b",
	"./card-illustration/sunny-day.png": "3390",
	"./card-illustration/time-traveler.png": "0bda",
	"./card-illustration/time_machine.png": "059d",
	"./card-illustration/undefinedCard.png": "af8a",
	"./card-illustration/venus-statue.png": "6a6d",
	"./card-illustration/werewolf.png": "1979",
	"./card-illustration/xray-glasses.png": "7e19",
	"./cards/copper_back.png": "e21f",
	"./cards/copper_normal.png": "7132",
	"./cards/gold_back.png": "b8c3",
	"./cards/gold_normal.png": "4f59",
	"./cards/silver_back.png": "24bf",
	"./cards/silver_normal.png": "d5fa",
	"./chest-0.png": "07a8",
	"./chestIron/chest-0.png": "cf8e",
	"./chestIron/chest-1.png": "16ff",
	"./chestIron/chest-10.png": "961a",
	"./chestIron/chest-11.png": "793a",
	"./chestIron/chest-2.png": "3574",
	"./chestIron/chest-3.png": "d3b7c",
	"./chestIron/chest-4.png": "de01",
	"./chestIron/chest-5.png": "0ea4",
	"./chestIron/chest-6.png": "0828",
	"./chestIron/chest-7.png": "952a",
	"./chestIron/chest-8.png": "f381",
	"./chestIron/chest-9.png": "99ff",
	"./chestIron/chest.png": "fbf1",
	"./chestStand/chest-0.png": "605d",
	"./chestStand/chest-1.png": "f556",
	"./chestStand/chest-10.png": "b6b9",
	"./chestStand/chest-2.png": "3cb2",
	"./chestStand/chest-3.png": "580a",
	"./chestStand/chest-4.png": "1c60",
	"./chestStand/chest-5.png": "3521",
	"./chestStand/chest-6.png": "b29c",
	"./chestStand/chest-7.png": "2d6e",
	"./chestStand/chest-8.png": "7306",
	"./chestStand/chest-9.png": "940a",
	"./chestStand/chest.png": "7f8d",
	"./clock/clock.png": "c28f",
	"./clock/clockBig.png": "2b02",
	"./clock/clockSmall.png": "2cf8",
	"./clock/smoke.png": "4b96",
	"./clue.png": "82cc",
	"./copyMachine/print.png": "6a7e",
	"./copyMachine/scan.png": "9555",
	"./emerald.png": "2f03",
	"./empty-card.png": "9aad",
	"./excavation/background.png": "6c7c",
	"./excavation/brush.png": "c01d",
	"./excavation/cutout/0.png": "7f98",
	"./excavation/cutout/1.png": "8fad",
	"./excavation/cutout/2.png": "7fe0",
	"./excavation/cutout/2bis.png": "1635",
	"./excavation/cutout/3.png": "b2ef",
	"./excavation/cutout/4.png": "6a83",
	"./excavation/foreground.png": "a8cf",
	"./excavation/foregroundMobile.png": "6574",
	"./excavation/obj2.png": "60c7",
	"./excavation/obj3.png": "cc81",
	"./excavation/septre0.png": "899e",
	"./excavation/septre1.png": "d30e",
	"./excavation/septre2.png": "b802",
	"./final.png": "499d",
	"./foothead.png": "22f1",
	"./leather.png": "a967",
	"./new.png": "2596",
	"./newTag.png": "c117",
	"./painting.png": "84e3",
	"./right.png": "5712",
	"./safe/arrow-left.png": "4efc",
	"./safe/arrow-right.png": "e48b",
	"./safe/back.png": "fe8e",
	"./safe/numb.png": "72b3",
	"./scene_image/bubble_1.png": "2217",
	"./scene_image/bubble_2.png": "b08f",
	"./scene_image/bubble_3.png": "f0fd",
	"./scene_image/dice_1.png": "9302",
	"./scene_image/dice_2.png": "fc34",
	"./scene_image/dice_3.png": "ea69",
	"./scene_image/dice_4.png": "30a3",
	"./scene_image/dice_5.png": "6047",
	"./scene_image/dice_6.png": "c3b0",
	"./scene_image/dice_step_1.png": "36c3",
	"./scene_image/dice_step_2.png": "096e",
	"./scene_image/empty.png": "42a5",
	"./scene_image/gum1.png": "eaf6",
	"./scene_image/gum2.png": "35e0",
	"./scene_image/hand.png": "544f",
	"./scene_image/pie_branch.png": "fc64",
	"./scene_image/pie_coin.png": "8957",
	"./scene_image/pie_diamond.png": "af87",
	"./scene_image/pie_leave.png": "d22f",
	"./scene_image/pie_necklace.png": "ed45",
	"./scene_image/skeleton_1.png": "4d17",
	"./scene_image/skeleton_2.png": "f2a5",
	"./scene_image/x_ray_1.png": "2209",
	"./scene_image/x_ray_2.png": "4639",
	"./scene_image/x_ray_3.png": "e262",
	"./scene_image/x_ray_4.png": "2953",
	"./scene_image/x_ray_5.png": "0f19",
	"./shop/boosterShop.png": "56b7",
	"./shop/level2.png": "516e",
	"./shop/level3.png": "0987",
	"./shop/moist.png": "5f36",
	"./shop/shop-back.png": "f162",
	"./shop/shop-front-mobile.png": "dec1",
	"./shop/shop-front.png": "6376",
	"./shop/venus.png": "1968",
	"./single0.png": "4737",
	"./test-night.png": "2ba4",
	"./test.png": "1552",
	"./tree.png": "c3f6",
	"./wheel.png": "40e8",
	"./wheelFast.png": "c4bf",
	"./woodStand/woodStand-0.png": "8335",
	"./woodStand/woodStand-1.png": "a5e6",
	"./woodStand/woodStand-10.png": "c488",
	"./woodStand/woodStand-2.png": "e0c8",
	"./woodStand/woodStand-3.png": "e55d",
	"./woodStand/woodStand-4.png": "0a8e",
	"./woodStand/woodStand-5.png": "278f",
	"./woodStand/woodStand-6.png": "3deb",
	"./woodStand/woodStand-7.png": "cbd8",
	"./woodStand/woodStand-8.png": "5bad",
	"./woodStand/woodStand-9.png": "56a6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";